import React from 'react';
import * as styles from './TemplateIcon.module.scss';
import SVGIcon from '../components/SVGIcon';
import templateIcon from '../icons/prefilled/16x16/template.svg';

const TemplateIcon = () => {
  return (
    <div className={styles.icon}>
      <SVGIcon>{templateIcon}</SVGIcon>
    </div>
  );
};

export default TemplateIcon;
